import { w as withConfigTransport } from "../../../services/config-transport/withConfigTransport-2705a6a5.mjs";
import { _ as _VaFileUploadListItem } from "./VaFileUploadListItem-ce270f29.mjs";
const VaFileUploadListItem = withConfigTransport(_VaFileUploadListItem);
export {
  VaFileUploadListItem as V
};
//# sourceMappingURL=index-dbcb2d22.mjs.map
